import React, { useState } from 'react';

import { Box, Separator, Text, ToggleGroup } from '@betterment/samba-react';

import AllTimeContributions from './components/allTimeContributions';
import CurrentYearContributions from './components/currentYearContributions';
import ShimmerLoader from './components/shimmerLoader';
import { useFourOhOneKContributionsCurrentYearQuery } from './hooks';

const FourOhOneKContributions: React.FC<React.PropsWithChildren> = () => {
  const [timePeriodSelection, setTimePeriodSelection] = useState('currentYear');
  const { isLoading, fourOhOneKContributionCurrentYear, employers } = useFourOhOneKContributionsCurrentYearQuery();

  return (
    <>
      {isLoading && <ShimmerLoader />}
      {!isLoading && fourOhOneKContributionCurrentYear && (
        <Box
          css={{
            borderWidth: 'thin',
            borderStyle: 'solid',
            borderColor: 'border.weak',
            borderRadius: 'radii.200',
            pt: 'space.400',
            pb: 'space.300',
            px: 'space.300',
          }}
        >
          <Box css={{ mb: 'space.200' }}>
            <Text>Your 401(k) contributions</Text>
          </Box>
          <Separator css={{ my: 'space.300' }} />
          <Box>
            <ToggleGroup
              onValueChange={(value: string) => {
                if (value !== '') {
                  setTimePeriodSelection(value);
                }
              }}
              spacing="default"
              type="single"
              value={timePeriodSelection}
            >
              <ToggleGroup.Item value="currentYear">
                <Text>This Year</Text>
              </ToggleGroup.Item>
              <ToggleGroup.Item value="allTime">
                <Text>All Time</Text>
              </ToggleGroup.Item>
            </ToggleGroup>
            {timePeriodSelection === 'currentYear' && (
              <CurrentYearContributions
                fourOhOneKContributionCurrentYear={fourOhOneKContributionCurrentYear}
                employers={employers || []}
              />
            )}
            {timePeriodSelection === 'allTime' && <AllTimeContributions />}
          </Box>
        </Box>
      )}
    </>
  );
};

export default FourOhOneKContributions;
